export default __webpack_public_path__ + "static/media/table-maps.5e5a3b9f.svg";